import { render } from "./OapMediaCarousel.vue?vue&type=template&id=b2856aa0"
import script from "./OapMediaCarousel.vue?vue&type=script&lang=js"
export * from "./OapMediaCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__